export const INSTITUCION_NOMBRE_COMPLETO = 'Colegio de Martilleros y Corredores Públicos de la Provincia de Buenos Aires';
export const MARCA_NOMBRE = 'MartillerosBA';
